import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=b4cf5efc&scoped=true"
import script from "./ListPage.vue?vue&type=script&lang=js"
export * from "./ListPage.vue?vue&type=script&lang=js"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=b4cf5efc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf5efc",
  null
  
)

export default component.exports